import React, { useEffect, useState } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import { calculateItemTotal, calculateTotal, formatModifierSummary } from '../../utils/itemUtils';
import '../../styles/MenuAndBillModal.css';

const ItemsChangeModal = ({
  show,
  handleClose,
  orderItems,
  orderNote = '',
  handleConfirmChanges,
  mode = 'edit-order',
}) => {
  const isNewOrder = mode === 'new-order';
  const isCashierAdd = mode === 'cashier-add';
  const [creationStatus, setCreationStatus] = useState('');
  const [showWarning, setShowWarning] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!show) {
      return;
    }

    setCreationStatus('');
    setShowWarning(false);
    setIsSubmitting(false);
  }, [show]);

  const handleSave = async () => {
    if (isNewOrder && !creationStatus) {
      setShowWarning(true);
      return;
    }

    setIsSubmitting(true);
    try {
      await handleConfirmChanges({
        items: orderItems,
        ...(isNewOrder ? { status: creationStatus } : {}),
        ...(orderNote ? { notes: orderNote } : {}),
      });
      handleClose();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" dialogClassName="venue-change-review-modal">
      <Modal.Header closeButton>
        <Modal.Title>{isNewOrder ? 'Siparişi Onayla' : isCashierAdd ? 'Adisyon Ürünlerini Onayla' : 'Değişiklikleri Onayla'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="venue-flow-alert venue-flow-alert--info mb-3">
          <strong>{isNewOrder ? 'Sipariş tipi seçilecek' : isCashierAdd ? 'Ürünler adisyona eklenecek' : 'Sipariş güncellenecek'}</strong>
          {'\n'}
          {isNewOrder
            ? 'Kaydetmeden önce siparişin yeni sipariş olarak mı açılacağını, yoksa tamamlanmış olarak mı ekleneceğini seçin.'
            : isCashierAdd
              ? 'Kaydettiğinizde seçilen ürünler mevcut açık adisyona tamamlanmış olarak eklenecek.'
              : 'Kaydettiğinizde mevcut siparişteki ürün listesi güncellenecek.'}
        </div>

        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Adet</th>
              <th>Ürün Adı</th>
              <th>Birim (TRY)</th>
              <th>Toplam (TRY)</th>
            </tr>
          </thead>
          <tbody>
            {orderItems.map((item, index) => (
              <tr key={item.orderItemId || item.id || index}>
                <td>{item.quantityChange || item.quantity}</td>
                <td>
                  <div>{item.name}</div>
                  {item.modifiers?.length ? (
                    <div className="small text-muted mt-1">{formatModifierSummary(item.modifiers)}</div>
                  ) : null}
                  {item.notes ? (
                    <div className="small text-muted mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      <strong>Not:</strong> {item.notes}
                    </div>
                  ) : null}
                </td>
                <td>{item.price.toFixed(2)}</td>
                <td>{calculateItemTotal(item)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="total">
          <strong>Toplam: {calculateTotal(orderItems)} TRY</strong>
        </div>
        {orderNote ? (
          <div className="venue-change-review-note mt-3">
            <strong className="d-block mb-1">Sipariş notu</strong>
            <div className="small text-muted" style={{ whiteSpace: 'pre-wrap' }}>
              {orderNote}
            </div>
          </div>
        ) : null}
        {isNewOrder ? (
          <div className="venue-order-type-picker mt-3">
            <button
              type="button"
              className={`venue-order-type-option ${creationStatus === 'pending' ? 'selected' : ''}`}
              onClick={() => {
                setCreationStatus('pending');
                setShowWarning(false);
              }}
            >
              <strong className="venue-order-type-option__title">Yeni Sipariş</strong>
              <span className="venue-order-type-option__text">
                Sipariş aktif iş akışına yeni sipariş olarak eklenir.
              </span>
            </button>
            <button
              type="button"
              className={`venue-order-type-option ${creationStatus === 'completed' ? 'selected' : ''}`}
              onClick={() => {
                setCreationStatus('completed');
                setShowWarning(false);
              }}
            >
              <strong className="venue-order-type-option__title">Tamamlanmış Olarak Ekle</strong>
              <span className="venue-order-type-option__text">
                Önceden verilmiş ama sisteme girilmemiş ürünler için kullanın.
              </span>
            </button>
          </div>
        ) : null}
        {showWarning ? (
          <p className="text-danger mt-3 mb-0">Sipariş tipi seçilmeden kaydedilemez.</p>
        ) : null}
      </Modal.Body>
      <Modal.Footer>
        <div className="venue-modal-actions">
          <Button variant="outline-secondary" onClick={handleClose}>
            Geri Dön
          </Button>
          <div className="venue-modal-actions__spacer" />
          <Button variant="success" onClick={handleSave} disabled={isSubmitting}>
            {isSubmitting ? 'Kaydediliyor...' : isNewOrder ? 'Siparişi Kaydet' : isCashierAdd ? 'Ürünleri Ekle' : 'Değişiklikleri Kaydet'}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ItemsChangeModal;
